<template>
  <v-card
    :loading="loading"
    width="100%"
    class="pa-5"
    height="100%"
  >
    <v-card-title
      class="justify-center my-0 py-0 primary--text"
    >
      {{ title }}
      <slot name="action-button"></slot>
    </v-card-title>
    <div>
      <assignment-form
        ref="assignmentForm"
        :childEmployee="childEmployee"
        :ageRules="ageRules"
      ></assignment-form>
      <v-alert
        v-if="message"
        outlined
        border="left"
        :color="status ? 'success' : 'error'"
        dense
        class="text-caption"
      >
        {{ message }}
      </v-alert>
    </div>
  </v-card>
</template>

<script>
const AssignmentForm = () => import("../forms/AssignmentForm");

export default {
  components: {
    AssignmentForm
  },
  props: {
    title: {
      type: String,
      default: null
    },
    childEmployee: { type: Boolean, default: false },
    ageRules: {
      type: Array,
      default: () => {
        return [];
      }
    },
    message: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    // message: "",
    // saved: null,
    // loading: false
  }),
  methods: {
    getFormData() {
      let ref = this.$refs.assignmentForm;
      
      return ref.form;
    },
    validateForm() {
      let ref = this.$refs.assignmentForm;

      return ref.validate();
    }
  }
};
</script>
